import { Fragment } from 'react';
import { Text, Heading, CaretRight } from '@hungryroot/ui-kit';
import styles from './Breadcrumb.module.css';

const defaultBreadcrumbs = ['About you', 'Claim Offer', 'Checkout'] as const;

type DefaultBreadcrumbs = (typeof defaultBreadcrumbs)[number];

type Props<T extends string = DefaultBreadcrumbs> = {
  selected: T;
  breadcrumbs?: readonly T[];
};

export function Breadcrumb<T extends string = DefaultBreadcrumbs>({
  selected,
  breadcrumbs = defaultBreadcrumbs as unknown as readonly T[],
}: Props<T>) {
  const activeIndex = breadcrumbs.indexOf(selected);
  const { length: breadcrumbsLength } = breadcrumbs;
  return (
    <nav aria-label="Breadcrumb">
      <ol className={styles.container}>
        {breadcrumbs.map((label, index) => {
          const isActive = label === selected;
          return (
            <Fragment key={label}>
              {isActive === true ? (
                <li aria-current="step">
                  <Heading className={styles.active} variant="H6">
                    {label}
                  </Heading>
                </li>
              ) : (
                <li>
                  <Text className={index > activeIndex ? styles.future : ''}>
                    {label}
                  </Text>
                </li>
              )}
              {index !== breadcrumbsLength - 1 && (
                <li aria-hidden="true" className={styles.caret}>
                  <CaretRight />
                </li>
              )}
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
